import Constant from '@/const'
import Store from '@/store/index.js'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // アカウントリスト取得
    getAccountList({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.ACCOUNT}`,
        params: data,
        error: { message: 'アカウントリストの取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // アカウント情報取得
    getAccount({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: `${Constant.API_URL.ACCOUNT}/get`,
        error: { message: 'アカウント情報の取得に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // アカウント情報登録
    async setAccount({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.ACCOUNT}`,
        params: data,
        error: { message: 'アカウント情報の登録に失敗しました。' },
      }
      await dispatch('http/post', { ...request }, { root: true })
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // アカウント情報更新
    async updateAccount({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.ACCOUNT}/${data.ID}`,
        params: data,
        error: { message: 'アカウント情報の更新に失敗しました。' },
      }
      await dispatch('http/put', { ...request }, { root: true })
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // アカウント情報削除
    async delAccount({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.ACCOUNT}/${data.ID}`,
        params: data,
        error: { message: 'アカウント情報の削除に失敗しました。' },
      }
      await dispatch('http/delete', { ...request }, { root: true })
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // アカウント情報更新
    async validEmail({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.VALID_EMAIL}`,
        params: data,
        error: { message: 'メールアドレス重複チェックに失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 取引先リスト取得
    getTorihikiList({ commit, dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.TORIHIKI}`,
        params: data,
        error: { message: '取引先リストの取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // アクティベートメール再送信
    reSendValidMail({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.ACCOUNT}/resend_valid_email`,
        params: data,
        error: { message: 'アクティベートメール送信に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js